import React from "react";

const ManifestContext = React.createContext();

export const ManifestProvider = ManifestContext.Provider;
export const ManifestConsumer = ManifestContext.Consumer;

export default ManifestContext;
